/** @type {import('next-i18next').UserConfig} */

/**
 * NOTE: Can't import the constants here since our constants are in typescript.
 * Using hardcoded values below based on the constants in src/config/i18n.config.ts
 */
module.exports = {
  i18n: {
    /**
     * ISSUE: There is no way to differentiate between path without locale and path with default locale.
     * So we are using 'default' as default locale that points to 'en-US' locale in app.
     *
     * TODO: Find a better solution to handle this.
     */
    defaultLocale: 'default-locale',
    locales:
      process.env.NEXT_PUBLIC_ENABLE_I18N === 'true'
        ? ['default-locale', 'US', 'CA', 'en-US', 'en-CA', 'fr-CA']
        : ['default-locale'],
    localeDetection: false,
  },
  fallbackLng: locale => {
    if (locale === 'en-CA') return 'en-US'
    return 'en-US'
  },
  localePath: './public/locales',
  localeStructure: '{{lng}}/{{ns}}',
  reloadOnPrerender: process.env.NODE_ENV === 'development',
  serializeConfig: false,
  debug: false,
}
